var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGraphAsc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4904 2.84961H6.50981C4.48834 2.84961 2.84961 4.48834 2.84961 6.50981V17.4904C2.84961 19.5119 4.48834 21.1506 6.50981 21.1506H17.4904C19.5119 21.1506 21.1506 19.5119 21.1506 17.4904V6.50981C21.1506 4.48834 19.5119 2.84961 17.4904 2.84961Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03516 12H9.43206C9.80444 12 10.1616 11.8521 10.4249 11.5888L12.4957 9.51794C13.0441 8.96961 13.9331 8.96961 14.4814 9.51794L16.9635 12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGraphAsc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_graph_asc.b0fde604d0a79447deca103c4106d2f4.svg";